import removeElement from './removeElement';
import { getNavEl } from './getNavEl';
export function getOrAddGlobalToolbarContainer() {
  let globalToolbarContainer = document.querySelector('#hs-global-toolbar-root');
  if (!globalToolbarContainer) {
    globalToolbarContainer = document.createElement('div');
    globalToolbarContainer.id = 'hs-global-toolbar-root';
    const navParent = getNavEl();
    const notificationBannerContainer = getOrAddUtilityBannersContainer();
    if (navParent) {
      navParent.insertBefore(globalToolbarContainer, notificationBannerContainer.nextSibling);
    }
  }
  return globalToolbarContainer;
}
export function addVerticalNavContainer() {
  const container = document.createElement('div');
  container.id = 'hs-vertical-nav-root';
  document.querySelector('#hs-nav-v4').insertAdjacentElement('afterend', container);
  return container;
}
export function addFeedbackModalRoot() {
  const container = document.createElement('div');
  container.id = 'hs-vertical-nav-feedback-modal-root';
  document.body.appendChild(container);
  return container;
}
export function getOrAddUtilityBannersContainer() {
  const notificationsBannerContainerId = 'notificationBannerContainer';
  let bannerContainer = document.getElementById(notificationsBannerContainerId);
  if (!bannerContainer) {
    bannerContainer = document.createElement('div');
    bannerContainer.setAttribute('id', notificationsBannerContainerId);
    bannerContainer.setAttribute('data-test-id', notificationsBannerContainerId);
    getNavEl().prepend(bannerContainer);
  }
  return bannerContainer;
}
export function addRootNavContainer() {
  const container = document.createElement('div');
  container.id = 'hs-one-nav-root';
  document.querySelector('#hs-nav-v4').insertAdjacentElement('afterend', container);
  return container;
}
export const addHeadlessNavContainer = () => {
  const container = document.createElement('div');
  container.id = 'hs-headless-nav-root';
  document.querySelector('#hs-nav-v4').insertAdjacentElement('afterend', container);
  return container;
};
export function getCallingContainer() {
  return getNavEl().querySelector('[data-portal-hook="marketplace-menu"]');
}
export const horizontalPlaceholderSelector = '#hs-nav-v4 .main-nav';
export const verticalPlaceholderSelector = '#placeholder-vertical-nav';
export function removeNavPlaceholders() {
  removeElement(horizontalPlaceholderSelector);
  removeElement(verticalPlaceholderSelector);
}
export function removeVerticalNavPlaceholder() {
  removeElement(verticalPlaceholderSelector);
}
export function removeGlobalToolbarPlaceholder() {
  removeElement(horizontalPlaceholderSelector);
}